// extracted by mini-css-extract-plugin
export default {"navbar":"Menu_navbar__l-g9V","espacamento":"Menu_espacamento__oYnCA","tamanhoMenuItem":"Menu_tamanhoMenuItem__8Khek","pi":"Menu_pi__NINWE"};